/** Shared AmitaSoft marketing tokens (aligned with website-amitasoft). */
export const AMITASOFT_BRAND = {
  deepPurple: "#6A8AFF",
  primary: "#89AAF5",
  accentCyan: "#B2FBFF",
  accentInteractive: "#6A8AFF",
  textDark: "#0B0F3A",
  textMuted: "#4C5270",
  textNavy: "#0B0F3A",
  lightGray: "#EDF0F2",
  footerPartnerBg: "#f0f4ff",
  footerBorder: "#d4dcf0",
  blogCardImageBg: "#eef2ff",
  pageBg: "#FCFCFC",
  white: "#ffffff",
  gradientPartner: "linear-gradient(45deg, #6A8AFF 14.64%, #B2FBFF 85.36%)",
  gradientHero: "linear-gradient(135deg, #6A8AFF 0%, #89AAF5 45%, rgba(178, 251, 255, 0.45) 100%)",
  maxContent: 1280,
  contactEmail: "support@amitasoft.com",
  contactPhone: "+1 408-430-3650",
  siteName: "AmitaSoft",
  blogTitle: "AmitaSoft Blogs",
  blogTagline: "Insights on Digital Transformation and Enterprise Trust",
};
